import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const amenitiesAdapter = createEntityAdapter({});

const initialState = amenitiesAdapter.getInitialState();

export const amenitiesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAmenities: builder.query({
      query: () => "/amenities",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedAmenities = responseData.map((amenity) => {
          amenity.id = amenity._id;
          return amenity;
        });
        return amenitiesAdapter.setAll(initialState, loadedAmenities);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Amenity", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Amenity", id })),
          ];
        } else return [{ type: "Amenity", id: "LIST" }];
      },
    }),
    addNewAmenity: builder.mutation({
      query: (initialAmenityData) => ({
        url: "/amenities",
        method: "POST",
        body: {
          ...initialAmenityData,
        },
      }),
      invalidatesTags: [{ type: "Amenity", id: "LIST" }],
    }),
    updateAmenity: builder.mutation({
      query: (initialAmenityData) => ({
        url: "/amenities",
        method: "PATCH",
        body: {
          ...initialAmenityData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Amenity", id: arg.id },
      ],
    }),
    deleteAmenity: builder.mutation({
      query: ({ id }) => ({
        url: `/amenities`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Amenity", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetAmenitiesQuery,
  useAddNewAmenityMutation,
  useUpdateAmenityMutation,
  useDeleteAmenityMutation,
} = amenitiesApiSlice;

// returns the query result object
// export const selectAmenitiesResult =
//   amenitiesApiSlice.endpoints.getAmenities.select();

// // creates memoized selector
// const selectAmenitiesData = createSelector(
//   selectAmenitiesResult,
//   (amenitiesResult) => amenitiesResult.data // normalized state object with ids & entities
// );

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//   selectAll: selectAllAmenities,
//   selectById: selectAmenityById,
//   selectIds: selectAmenityIds,
//   // Pass in a selector that returns the amenities slice of state
// } = amenitiesAdapter.getSelectors(
//   (state) => selectAmenitiesData(state) ?? initialState
// );
